import addClass from '../../../general/class/addClass';
import hasAttr from '../../../general/attr/hasAttr';
import hasClass from '../../../general/class/hasClass';
import removeClass from '../../../general/class/removeClass';

import exLanguage from '../../../language';
import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function multiple(ctx: Context): any {
    function start(): void {
        settings();

        // Foreach Data
        for (const option of ctx.shared.state.data) {
            //
            if (option.hidden) {
                ctx.shared.config.placeholder = option.text;
                continue;
            }

            // If there is no value and text
            if (!option.value && !option.text) {
                continue;
            }

            // Create
            const itemCreate = create(option);
            ctx.shared.elements.listing.dropdown.appendChild(itemCreate.element);

            // Options Push
            ctx.shared.state.options.push({
                element: itemCreate.link,
                option: option,
            });
        }

        progress();
    }

    function create(element: HTMLOptionElement): Record<string, any> {
        const elements: Record<string, any> = {};

        // Create element (item)
        const elItem = exElement.create({
            tag: 'li',
        });
        elements.element = elItem;

        elItem.addEventListener('click', function (evt): any {
            // If there is disabled
            if (hasAttr(elLink, 'disabled')) {
                evt.stopPropagation();
            }

            evt.stopPropagation();
        });

        // ------------------------------------------------------------

        //
        const elLink = ctx.option.createItem(element);
        elItem.appendChild(elLink);
        elements.link = elLink;
        //
        elLink.addEventListener('click', function (this: any): any {
            //
            if (hasClass(this, 'selected active')) {
                removeClass(this, 'selected active');
            } else {
                addClass(this, 'selected active');
            }

            //
            progress();
        });

        // ------------------------------------------------------------

        // Return
        return elements;
    }

    function settings(): void {
        // If using select all
        if (ctx.shared.config.multi?.isSelectAll === true) {
            // Create element (item)
            const elItem = exElement.create({
                tag: 'li',
            });
            ctx.listing.getDropdownElement().appendChild(elItem);

            // ----------------------------------------------------------------

            // Create element (link)
            const elLink = exElement.create({
                tag: 'a',
                class: {
                    new: 'dropdown-item',
                },
                html: exLanguage.line('select.select_all'),
            });
            elItem.appendChild(elLink);
            ctx.shared.elements.listing.selectAll = elLink;

            // Create event (click)
            elLink.addEventListener('click', function (evt): any {
                // If there is disabled
                if (hasAttr(this, 'disabled')) {
                    evt.stopPropagation();
                    return;
                }

                // Foreach Options
                for (const { element } of ctx.option.getOptions()) {
                    if (hasClass(this, 'selected')) {
                        if (hasClass(element, 'selected')) {
                            removeClass(element, 'selected active');
                        }
                    } else {
                        if (!hasClass(element, 'selected')) {
                            addClass(element, 'selected active');
                        }
                    }
                }

                //
                hasClass(this, 'selected active')
                    ? removeClass(this, 'selected active')
                    : addClass(this, 'selected active');

                //
                progress();
            });

            // ----------------------------------------------------------------

            // Create element (divider)
            const elDivider = exElement.create({
                class: {
                    new: 'select-divider',
                },
            });
            ctx.listing.getDropdownElement().appendChild(elDivider);
        }
    }

    // ------------------------------------------------------------------------

    function progress(): void {
        const listValue: string[] = [];
        const listText: string[] = [];

        // Foreach Options
        for (const { element, option } of ctx.option.getOptions()) {
            // If there is selected
            if (hasClass(element, 'selected')) {
                listValue.push(option.value);
                listText.push(option.text);
            }
        }

        // --------------------------------------------------------------------

        if (ctx.shared.config.multi?.isSelectAll === true) {
            //
            if (listText.length === ctx.shared.state.options.length) {
                addClass(ctx.shared.elements.listing.selectAll, 'selected active');
            }
            //
            else {
                removeClass(ctx.shared.elements.listing.selectAll, 'selected active');
            }
        }

        // --------------------------------------------------------------------

        //
        const placeholder = ctx.shared.config.placeholder ?? 'select.no_selected';

        // If using text format
        if (ctx.shared.config.select?.isTextFormat === true) {
            const text = listText.length
                ? exLanguage.line('select.items_selected', { count: listText.length })
                : exLanguage.line(placeholder);

            ctx.text.setValue(text);
        } else {
            const text = listText.length ? listText.join(', ') : exLanguage.line(placeholder);

            ctx.text.setValue(text);
        }

        // --------------------------------------------------------------------

        // Set current value
        ctx.current.setValue(listValue);
    }

    // ------------------------------------------------------------------------

    return {
        start,
        progress,
    };
}

// ----------------------------------------------------------------------------

export default multiple;
